"use strict"
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { Env } from './Env';

interface mCamera extends THREE.Camera {
    fov: number;
    far: number;
    near: number;
    aspect: number;
    getEffectiveFOV: () => number;
    getFocalLength: () => number;
    updateProjectionMatrix: () => void;
}

export class Camera {

    static camera: mCamera;
    static orbitControls: OrbitControls;
    constructor() {
        const camera = new THREE.PerspectiveCamera();
        camera.fov = 25;
        camera.aspect = Env.canvas_size.width / Env.canvas_size.height;
        camera.near = 0.1;
        camera.far = 50000;
        let cameraPosition = new THREE.Vector3(13.25, 5.3, 13.25);
        camera.position.copy(cameraPosition);
        camera.updateProjectionMatrix();
        Camera.camera = camera;
    }
    static setOrbitControls(): void {
        const controls = new OrbitControls(Camera.camera, Env.inputElement);
        // controls.maxPolarAngle = .9 * Math.PI / 2;
        controls.minDistance = 0;
        controls.maxDistance = 50000;
        // controls.enablePan = false;
        controls.enableDamping = true;
        controls.dampingFactor = 0.1;
        controls.rotateSpeed = 0.8;
        controls.enableZoom = true;
        controls.touches = {
            ONE: THREE.TOUCH.ROTATE,
            TWO: THREE.TOUCH.DOLLY_PAN
        }
        controls.addEventListener('change', function (e) {
            self.postMessage({ cameraSettings: Camera.getCameraSettings() });
        })
        Camera.orbitControls = controls;
    }

    static getCameraSettings(): CameraSettings {
        const json = new CameraSettings({});
        json.camera_fov = Camera.camera.fov;
        json.camera_near = Camera.camera.near;
        json.camera_far = Camera.camera.far;
        json.camera_aspect = Camera.camera.aspect;
        json.camera_position_x = Camera.camera.position.x;
        json.camera_position_y = Camera.camera.position.y;
        json.camera_position_z = Camera.camera.position.z;
        json.camera_lens = Camera.camera.getFocalLength();
        json.camera_view_angle = Camera.camera.getEffectiveFOV();
        json.controls_target_x = Camera.orbitControls.target.x;
        json.controls_target_y = Camera.orbitControls.target.y;
        json.controls_target_z = Camera.orbitControls.target.z;
        return json;
    }

    static setCameraSettings(json: any): void {
        Camera.camera.fov = json.camera_fov;
        Camera.camera.near = json.camera_near;
        Camera.camera.far = json.camera_far;
        Camera.camera.aspect = json.camera_aspect;
        Camera.camera.position.x = json.camera_position_x;
        Camera.camera.position.y = json.camera_position_y;
        Camera.camera.position.z = json.camera_position_z;
        Camera.orbitControls.target.x = json.controls_target_x;
        Camera.orbitControls.target.y = json.controls_target_y;
        Camera.orbitControls.target.z = json.controls_target_z;
        Camera.camera.updateProjectionMatrix();
    }
}

class CameraSettings {
    constructor(json: object) {
        if (Object.keys(json).length > 0) {
            for (const i in json) {
                this[i] = json[i];
            }
            this.issetvalue = true;
        } else {
            this.issetvalue = false;
        }
    }
    camera_fov: number;
    camera_near: number;
    camera_far: number;
    camera_aspect: number;
    camera_position_x: number;
    camera_position_y: number;
    camera_position_z: number;
    camera_rotation_x: number;
    camera_lens: number;
    camera_view_angle: number;
    controls_target_x: number;
    controls_target_y: number;
    controls_target_z: number;
    issetvalue: boolean;
}